/**
 * PilotHeader component.
 */
import Clock from '@components/atoms/text/pilotClock';
import Dial from '@components/atoms/text/pilotDial';
import Recording from '@components/elements/dial/dialRecording';
import usePilotHeader from './usePilotHeader';
import { PilotProps as Props } from '@shared/types/props/pilot';

/**
 * Displays the pilot header component. Includes the clock and dial.
 */
export default function PilotHeader(parentProps: Props) {
  const { display, text } = usePilotHeader(parentProps);
  return (
    <>
      <Clock />
      <Recording display={display.recording} />
      <Dial display={display.dial}>{text}</Dial>
    </>
  );
}
